import { Card } from '@/components/ui/card';
import { SCENARIOS } from '../data/productivity-rates';
import { StaggerChildren, StaggerItem } from '@/components/motion';

export function ScenarioCards() {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-center text-muted-foreground">
        Qué podrías haber ganado con IA
      </h3>

      <StaggerChildren className="grid gap-3" staggerDelay={0.06}>
        {SCENARIOS.map((s) => (
          <StaggerItem key={s.label}>
            <Card className="p-4 hover:bg-accent/50 transition-colors">
              <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                {/* Scenario label */}
                <div className="flex items-center gap-2 sm:w-44 shrink-0">
                  <span className="text-2xl">{s.emoji}</span>
                  <div>
                    <p className="font-semibold text-sm">{s.label}</p>
                    <p className="text-xs text-muted-foreground">
                      {s.minutes >= 60 ? `${s.minutes / 60}h` : `${s.minutes} min`}
                    </p>
                  </div>
                </div>

                {/* Stats */}
                <div className="flex flex-wrap gap-4 sm:gap-6 text-sm">
                  <Stat
                    value={`$${s.cost.toLocaleString('es-CL')}`}
                    label="ahorro"
                    color="text-red-400"
                  />
                  <Stat value={String(s.tasks)} label="tareas extra" color="text-orange-400" />
                  <Stat value={String(s.prs)} label="PRs extra" color="text-yellow-400" />
                  <Stat value={`${s.minutesSaved} min`} label="ahorrados" color="text-green-400" />
                </div>
              </div>
            </Card>
          </StaggerItem>
        ))}
      </StaggerChildren>
    </div>
  );
}

function Stat({ value, label, color }: { value: string; label: string; color: string }) {
  return (
    <div className="flex items-baseline gap-1">
      <span className={`font-bold tabular-nums ${color}`}>{value}</span>
      <span className="text-muted-foreground text-xs">{label}</span>
    </div>
  );
}
